import React, { use, useCallback } from "react";
import { StyleSheet } from "react-native";
import { useI18n } from "../../hooks/i18n-hooks";
import VStack from "../../ui_atoms/VStack";
import { AuthManagerContext } from "../../contexts/AuthManager";
import { useMutation } from "@apollo/client/react";
import { VERIFICATION_RESET } from "../../graphql/identity";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useIntercom } from "../../hooks/intercom";
import ScreenCard from "../ScreenCard";
import { kycGradient } from "../../configs/linear-gradients";
import { LiftPerson } from "../../components/LiftPerson";

const IdVerificationRetry = () => {
    const i18n = useI18n();
    const { presentIntercom } = useIntercom();
    const insets = useSafeAreaInsets();
    const { user, refreshUser } = use(AuthManagerContext);
    const [verificationReset, { error, loading }] = useMutation(VERIFICATION_RESET);

    const reasonCode = user?.kycStatus?.reasonCode;

    const onRetry = useCallback(async () => {
        await verificationReset();
        void refreshUser?.();
    }, [refreshUser, verificationReset]);

    return (
        <ScreenCard
            backgroundGradient={kycGradient}
            headband={
                error
                    ? {
                          text: error.message,
                          mode: "error",
                      }
                    : undefined
            }
            buttons={[
                {
                    title: i18n.t("screens.auth.idVerificationRetry.nextButton"),
                    onPress: onRetry,
                    isValid: !loading,
                    validating: loading,
                    mode: "secondary",
                },
                {
                    title: i18n.t("assistance"),
                    onPress: () => {
                        void presentIntercom();
                    },
                    isValid: !loading,
                    size: "medium",
                    mode: "primary",
                },
            ]}
            contentStyle={{
                paddingTop: insets.top,
                paddingBottom: 0,
            }}
            scrollEnabled={false}
            isContentContainerFlex
        >
            <VStack v={1} h={1} style={{ flex: 1 }}>
                <LiftPerson
                    markdownProps={{
                        markdown: `${i18n.t("screens.auth.idVerificationRetry.description")}${reasonCode ? `\n\n${i18n.t(`screens.auth.idVerificationRetry.veriffCodes.${reasonCode}`)}` : ""}`,
                    }}
                />
            </VStack>
        </ScreenCard>
    );
};

export default IdVerificationRetry;
